import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  AboutUs,
  AddAddress,
  Chats,
  ConfirmComplete,
  EditAddress,
  EditProfile,
  EditRequestAcceptance,
  EditRequestExtraItems,
  EditRequestItems,
  MakePayement,
  MyCards,
  NotFound,
  RefferralProgram,
  RequestDetails,
  Requests,
  ShowAll,
  LiveMapTracking,
  ProfileReviews,
  CongratulationScreen,
  SignConfirmationLetter,
} from "../pages";

function Routes() {
  return (
    <Switch>
      <Redirect exact from="/dashboard" to="/dashboard/my-requests" />

      <Route
        exact
        path="/dashboard/congratulations"
        component={CongratulationScreen}
      />
      <Route exact path="/dashboard/edit-profile" component={EditProfile} />

      <Route
        exact
        path="/dashboard/review-profile"
        component={ProfileReviews}
      />

      <Route exact path="/dashboard/my-requests" component={Requests} />

      <Route
        exact
        path="/dashboard/my-requests/:requestId"
        component={RequestDetails}
      />
      <Route
        exact
        path="/dashboard/my-requests/add-address/:requestId"
        component={AddAddress}
      />
      <Route
        exact
        path="/dashboard/my-requests/edit-address/:requestId/:addressId"
        component={EditAddress}
      />

      <Route
        exact
        path="/dashboard/my-requests/change-request/:type/:requestId"
        component={EditRequestAcceptance}
      />
      <Route
        exact
        path="/dashboard/my-requests/make-payment/:requestId"
        component={MakePayement}
      />
      <Route
        exact
        path="/dashboard/my-requests/confirm-complete/:requestId"
        component={ConfirmComplete}
      />

      <Route
        exact
        path="/dashboard/my-requests/companies-list/:requestId"
        component={ShowAll}
      />
      <Route
        exact
        path="/dashboard/my-requests/tracking-location/:requestId"
        component={LiveMapTracking}
      />
      <Route path="/dashboard/chats" component={Chats} />
      <Route path="/dashboard/my-cards" component={MyCards} />
      <Route path="/dashboard/about-us" component={AboutUs} />
      <Route path="/dashboard/refferral-program" component={RefferralProgram} />
      {/* Sign Confirmation Letter */}
      <Route
        path="/dashboard/sign-confirmation-letter/:id"
        component={SignConfirmationLetter}
      />

      <Route path="/" component={NotFound} />
    </Switch>
  );
}

export default Routes;
